




import { Component, Vue } from 'vue-property-decorator';
import map from '../assets/map-optimized.webp';

@Component
export default class MapBackground extends Vue {
  configImage = {
    image: new Image(),
  };

  addImg(): void {
    this.configImage.image.src = map as string;
  }

  created() {
    this.addImg();
  }
}
